import { useTranslation } from 'react-i18next';
import apis from '../../../../utils/apis';
import { showFeedbackModal } from '../../../../store/actions/UserFeedbackActions';
import Button from '../../../shared/TailwindComponents/Button';
import { FaSpinner } from 'react-icons/fa';
import { PiLockKeyLight } from 'react-icons/pi';
import { useAppDispatch } from '../../../../store';
import { useState } from 'react';

const PasswordTab: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [isRequesting, setIsRequesting] = useState(false);

  const handleRequestPasswordChange = async () => {
    setIsRequesting(true);
    try {
      const response = await apis({
        method: 'POST',
        url: '/user-profile/request-password-change',
      });
      if (response && response.status === 200) {
        dispatch(
          showFeedbackModal({
            showModal: true,
            message: t('Check your email for a password reset link. After changing your password, you\'ll need to log in again.'),
            modalType: 'success',
            duration: 5000,
          })
        );
      }
    } catch (error) {
      if (!error) return;
      dispatch(
        showFeedbackModal({
          showModal: true,
          message: t('Failed to send password reset email. Please try again.'),
          modalType: 'error',
          duration: 3000,
        })
      );
    }
    setIsRequesting(false);
  };

  return (
    <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 animate-fade-in-up">
      <div className="px-4 sm:px-6 border-b border-gray-200 dark:border-gray-700 py-4 border-1">
        <h2 className="text-base font-semibold leading-7 text-gray-900 dark:text-white">
          {t('Change Password')}
        </h2>
        <p className="mt-1 text-sm leading-6 text-gray-600 dark:text-gray-400">
          {t('For security, password changes are handled via email. Click below to receive a password reset link.')}
        </p>
      </div>
      <div className="border mx-4 sm:mx-6 w-1/2 p-4 rounded-lg overflow-hidden bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-700">
        <div className="space-y-6">
          <div className="flex items-start gap-3">
            <PiLockKeyLight className="text-gray-500 mt-0.5 text-xl flex-shrink-0" />
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {t('We\'ll send a password reset link to your registered email address. After setting a new password, you\'ll need to log in again with your new credentials.')}
            </p>
          </div>
          <div className="flex justify-end">
            <Button
              variant="primary"
              size="small"
              type="button"
              disabled={isRequesting}
              onClick={handleRequestPasswordChange}
            >
              {isRequesting ? (
                <span className="flex items-center">
                  <FaSpinner className="animate-spin mr-2" />
                  {t('Sending...')}
                </span>
              ) : (
                t('Change Password')
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordTab;
